import { View, Pressable, Text } from 'react-native';
import { keeperDuelViewStyles as styles } from './KeeperDuelView.styles';
import { KeeperDuelWebView } from './KeeperDuelWebView';
import { KeeperDuelOverlays } from './KeeperDuelOverlays';
import { useKeeperDuelGame } from '../../../src/quiz/hooks/useKeeperDuelGame';
import { KEEPER_DUEL_TEST_IDS } from '../../../src/quiz/constants/keeperDuel.constants';

interface KeeperDuelViewProps {
  onMoreGames: () => void;
}

/** Keeper Duel — portrait, non-rotated; the duel runs in the WebView, overlays are RN-native. */
export function KeeperDuelView({ onMoreGames }: KeeperDuelViewProps) {
  const game = useKeeperDuelGame();

  const handleBack = () => {
    game.confirmExit();
    onMoreGames();
  };

  return (
    <View style={styles.container} testID={KEEPER_DUEL_TEST_IDS.view}>
      <Pressable
        style={({ pressed }) => [styles.backButton, pressed && styles.pressedDim]}
        onPress={handleBack}
      >
        <Text style={styles.backArrow}>←</Text>
      </Pressable>

      <View style={styles.canvasWrap}>
        <KeeperDuelWebView
          ref={(r) => game.bindWebView(r)}
          html={game.html}
          onMessage={game.onMessage}
        />
      </View>

      <KeeperDuelOverlays
        status={game.status}
        errorMessage={game.errorMessage}
        runOver={game.runOver}
        finalStreak={game.finalStreak}
        tier={game.tier}
        coinsAwarded={game.coinsAwarded}
        coinsLeftToday={game.coinsLeftToday}
        capReached={game.capReached}
        bestStreak={game.bestStreak}
        newBest={game.newBest}
        toast={game.toast}
        onRetry={game.retry}
        onPlayAgain={game.onPlayAgain}
        onMoreGames={onMoreGames}
      />
    </View>
  );
}
